import { useState } from "react";
import axios from "axios";
import "./Companies.css";

function Usuarios() {

    const [search, setSearch] = useState("");
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);

    const [users, setUsers] = useState([]);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        role: "employee"
    });

    const handleSearch = async (e) => {

        const value = e.target.value;

        setSearch(value);

        if (value.length < 2) {
            setCompanies([]);
            return;
        }

        try {

            const token = localStorage.getItem("token");

            const res = await axios.get(
                `/api/companies/search/${value}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setCompanies(res.data);

        } catch (error) {
            console.log(error);
        }
    };

    const selectCompany = async (company) => {

        setSelectedCompany(null);
        setUsers([]);


        const token = localStorage.getItem("token");

        try {

            const res = await axios.get(
                `/api/users/company/${company.id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setSelectedCompany(company);
            setUsers(res.data);

            setCompanies([]);
            setSearch(company.company_name);

        } catch (error) {
            console.log(error);
        }
    };

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        // VALIDAR LÍMITE DE USUARIOS
        if (
            users.length >= Number(selectedCompany.max_users)
        ) {
            alert(
                "⚠️ Esta empresa alcanzó el límite máximo de usuarios."
            );
            return;
        }

        if (!selectedCompany) {
            alert("Seleccione una empresa");
            return;
        }

        const token = localStorage.getItem("token");

        try {

            await axios.post(
                "/api/users/",
                {
                    ...formData,
                    company_id: selectedCompany.id
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            alert("Usuario creado correctamente 🚀");

            setFormData({
                name: "",
                email: "",
                password: "",
                role: "employee"
            });

            selectCompany(selectedCompany);

        } catch (error) {

            alert(
                error.response?.data?.detail ||
                "Error al crear usuario"
            );
        }
    };

    return (
        <div className="companies-container">

            <h1 className="companies-header">
                Gestión de Usuarios 👥
            </h1>

            {/* BUSCADOR */}

            <div className="companies-card">

                <div className="input-group">

                    <input
                        className="companies-input"
                        placeholder=" "
                        value={search}
                        onChange={handleSearch}
                    />

                    <label>
                        Buscar empresa por NIT o nombre
                    </label>

                </div>

                {
                    companies.length > 0 && (

                        <div
                            style={{
                                marginTop: "15px"
                            }}
                        >

                            {
                                companies.map((company) => (

                                    <div
                                        key={company.id}
                                        className="company-item"
                                        onClick={() =>
                                            selectCompany(company)
                                        }
                                        style={{
                                            cursor: "pointer"
                                        }}
                                    >

                                        <div>

                                            <div className="company-name">
                                                {company.company_name}
                                            </div>

                                            <div className="company-meta">
                                                NIT: {company.nit}
                                            </div>

                                        </div>

                                    </div>

                                ))
                            }

                        </div>

                    )
                }

            </div>

            {
                selectedCompany && (

                    <>
                        <div className="companies-card">

                            <h2>
                                {selectedCompany.company_name}
                            </h2>

                            <p>
                                Plan: {selectedCompany.plan}
                            </p>

                            <p>
                                Usuarios utilizados:
                                {" "}
                                {users.length}
                                {" / "}
                                {selectedCompany.max_users}
                            </p>

                            <p>
                                Disponibles:
                                {" "}
                                {selectedCompany.max_users - users.length}
                            </p>
                            {
                                users.length >= Number(selectedCompany.max_users) && (
                                    <p
                                        style={{
                                            color: "#dc3545",
                                            fontWeight: "bold",
                                            marginTop: "10px"
                                        }}
                                    >
                                        ⚠️ Esta empresa ya alcanzó el límite máximo de usuarios.
                                    </p>
                                )
                            }

                        </div>

                        {/* FORMULARIO */}

                        <form
                            onSubmit={handleSubmit}
                            className="companies-card"
                        >

                            <div className="companies-grid">

                                <div className="input-group">

                                    <input
                                        className="companies-input"
                                        name="name"
                                        placeholder=" "
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />

                                    <label>
                                        Nombre
                                    </label>

                                </div>

                                <div className="input-group">

                                    <input
                                        className="companies-input"
                                        name="email"
                                        placeholder=" "
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />

                                    <label>
                                        Correo
                                    </label>

                                </div>

                                <div className="input-group">

                                    <input
                                        className="companies-input"
                                        type="password"
                                        name="password"
                                        placeholder=" "
                                        value={formData.password}
                                        onChange={handleChange}
                                        required
                                    />

                                    <label>
                                        Contraseña
                                    </label>

                                </div>

                                <div className="input-group">

                                    <select
                                        name="role"
                                        value={formData.role}
                                        onChange={handleChange}
                                        className="companies-input"
                                    >
                                        <option value="employee">
                                            Empleado
                                        </option>

                                        <option value="admin">
                                            Administrador
                                        </option>

                                        <option value="accountant">
                                            Contador
                                        </option>

                                        <option value="seller">
                                            Vendedor
                                        </option>
                                    </select>

                                </div>

                            </div>

                            <button
                                type="submit"
                                className="companies-btn"
                                disabled={
                                    users.length >= Number(selectedCompany?.max_users)
                                }
                            >
                                {
                                    users.length >= Number(selectedCompany?.max_users)
                                        ? "Límite Alcanzado"
                                        : "Crear Usuario"
                                }
                            </button>

                        </form>

                        {/* TABLA */}

                        <h2 className="companies-title">
                            Usuarios Registrados
                        </h2>

                        <div className="companies-table-container">

                            <table className="companies-table">

                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Correo</th>
                                        <th>Rol</th>
                                        <th>Estado</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {
                                        users.map((user) => (

                                            <tr key={user.id}>

                                                <td>
                                                    {user.name}
                                                </td>

                                                <td>
                                                    {user.email}
                                                </td>

                                                <td>
                                                    {user.role}
                                                </td>

                                                <td>
                                                    {
                                                        user.is_active
                                                            ? "Activo"
                                                            : "Bloqueado"
                                                    }
                                                </td>

                                            </tr>

                                        ))
                                    }

                                </tbody>

                            </table>

                        </div>

                    </>
                )
            }

        </div>
    );
}

export default Usuarios;